// Softly blended pet photography sitting behind section content.
export const PetBackdrop = ({ src, className = '', opacity = 0.18 }) => (
  <img
    src={src}
    alt=""
    aria-hidden="true"
    loading="lazy"
    style={{ opacity }}
    className={`pet-fade pointer-events-none absolute select-none object-cover ${className}`}
  />
);
